import React from 'react';

const Home: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-primary text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">MoreLove</h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            "The bond of perfectness"
          </p>
          <p className="text-lg md:text-xl mb-10 max-w-3xl mx-auto">
            Partager l'amour de Jésus-Christ à travers l'évangélisation et les œuvres sociales 
            pour le bien-être de la femme et de l'enfant
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a href="/donate" className="btn-donate">Faire un don</a>
            <a href="/membership" className="btn-secondary bg-white">Devenir membre</a>
          </div>
        </div>
      </section>

      {/* Citation Section */}
      <section className="py-16 bg-light">
        <div className="container mx-auto px-4 text-center">
          <blockquote className="text-2xl md:text-3xl max-w-4xl mx-auto">
            "Mais par dessus toute ces choses, revêtez-vous de la charité qui est le lien de la perfection"
            <footer className="mt-4 text-lg">Colossiens 3:14</footer>
          </blockquote>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-6">Qui sommes-nous</h2>
              <p className="mb-4">
                MORE LOVE Inc. (Plus d'amour) est une ONG Chrétienne de droit Américain, 
                créée dans l'État du Maryland aux États-Unis, reconnue comme une organisation 
                à but non lucrative sous le code 501(C)(3).
              </p>
              <p className="mb-6">
                Elle fédère en son sein des Associations et ONG œuvrant pour le bien-être 
                de la femme et de l'enfant.
              </p>
              <a href="/about" className="btn-primary">En savoir plus</a>
            </div>
            <div className="flex justify-center">
              <div className="rounded-lg overflow-hidden shadow-xl">
                <img 
                  src="/logo.jpeg" 
                  alt="MoreLove Logo" 
                  className="w-full h-auto max-w-md"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-16 bg-light">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-12 text-center">Notre mission</h2>
          <div className="max-w-3xl mx-auto">
            <p className="text-xl mb-8 text-center">
              La mission de More Love se résume ainsi :
            </p>
            <blockquote className="text-2xl text-center mb-8">
              « Partager l'amour de Jésus-Christ à travers l'évangélisation et les œuvres sociales 
              pour le bien être de la femme et de l'enfant »
            </blockquote>
            <div className="text-center">
              <a href="/mission" className="btn-primary">Découvrir notre mission</a>
            </div>
          </div>
        </div>
      </section>

      {/* Domains Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-12 text-center">Domaines d'intervention</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Domain 1 */}
            <div className="card">
              <h3 className="text-xl font-bold mb-4">Évangélisation</h3>
              <p>
                L'évangélisation de nos populations cibles (les femmes et les enfants)
              </p>
            </div>
            
            {/* Domain 2 */}
            <div className="card">
              <h3 className="text-xl font-bold mb-4">Édification mutuelle</h3>
              <p>
                L'édification mutuelle des membres à travers différentes activités
              </p>
            </div>
            
            {/* Domain 3 */}
            <div className="card">
              <h3 className="text-xl font-bold mb-4">Lutte contre la pauvreté</h3>
              <p>
                La lutte contre les disparités sociales notamment la pauvreté
              </p>
            </div>
            
            {/* Domain 4 */}
            <div className="card">
              <h3 className="text-xl font-bold mb-4">Soutien social</h3>
              <p>
                Le soutien des membres dans leurs activités sociales
              </p>
            </div>
            
            {/* Domain 5 */}
            <div className="card">
              <h3 className="text-xl font-bold mb-4">Activités génératrices</h3>
              <p>
                Le soutien à la création des activités génératrices de revenus
              </p>
            </div>
            
            {/* Domain 6 */}
            <div className="card">
              <h3 className="text-xl font-bold mb-4">Assistance et dons</h3>
              <p>
                L'assistance par des dons aux populations cibles
              </p>
            </div>
          </div>
          <div className="text-center mt-10">
            <a href="/domains" className="btn-primary">Tous nos domaines d'intervention</a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-secondary text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6 text-white">Rejoignez-nous dans notre mission</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Ensemble, nous pouvons faire une différence dans la vie des femmes et des enfants.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a href="/donate" className="btn-donate">Faire un don</a>
            <a href="/contact" className="bg-white text-secondary px-6 py-2 rounded-md hover:bg-opacity-90 transition-all">Contactez-nous</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
